(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('massive-properties', {
                parent: 'entity',
                url: '/tab-objects-properties',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/massive-properties-update.html',
                        controller: 'MassivePropertiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabProperties');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }]
                }
            }).state('massive-properties.update', {
                parent: 'massive-properties',
                url: '/update/:id',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objectstype-properties.html',
                        controller: 'TabObjectTypesPropertiesController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    id:null,
                    objects: []
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        return $translate.refresh();
                    }],
                    properties: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.queryByType({id: $stateParams.id});
                    }],
                    occurrence: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.occurrence({objectUniqueCodes: $stateParams.objects});
                    }]
                }
            });
    }

})();
